export interface AutocompleteStateModel<TItem> {
  requestFilterModel?: Partial<TItem> | null;
  activeFilterModel: TItem | null;
  list: TItem[];
}

export const AutocompleteStateModelDefault = {
  requestFilterModel: null,
  activeFilterModel: null,
  list: [],
};

export function getAutocompleteStateModelDefault<TItem>(
  overrides: Partial<
    AutocompleteStateModel<TItem>
  > = AutocompleteStateModelDefault
): AutocompleteStateModel<TItem> {
  const rv = {
    ...AutocompleteStateModelDefault,
    ...overrides,
  };

  return rv;
}
